import { unlinkOrganizationStudents } from 'api/admin'

/**
 * Unlink students from the current organization.
 * Uses the provided studentIds as-is (current selection for bulk).
 */
export async function unlinkSelectedStudents({ studentIds }) {
	const ids = (studentIds || []).map(item => String(item || '').trim()).filter(Boolean)

	if (!ids.length) {
		throw new Error('studentIds is required')
	}

	return unlinkOrganizationStudents({ studentIds: ids })
}
